// extracted by mini-css-extract-plugin
export default {"reply":"Reply_reply__9CjR+","user-image":"Reply_user-image__2Hg0r","reply-details":"Reply_reply-details__v8KaW"};